<template>
  <modal-layout>
    <popup-delivery-list
      :delivery-list="deliveryList"
      @set-delivery-location="chooseDeliveryLocation"
      @dispose="onDispose"
    />
  </modal-layout>
</template>
<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import modalMixin from '@/components/global/modal-mixin';
import orderApi from '@/apis/order';
import PopupDeliveryList from './PopupDeliveryList.vue';

export default {
  name: 'ModalDeliveryList',
  components: {
    ModalLayout,
    PopupDeliveryList,
  },
  mixins: [modalMixin],
  props: {
  },
  data() {
    return {
      deliveryList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const result = await orderApi.getDeliveryList();
      if (result.error) {
        return;
      }
      this.deliveryList = result;
    },
    chooseDeliveryLocation(e) {
      this.$emit('set-delivery-location', e);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modal-popups/ModalDeliveryList.vue